import {AbstractValidatorCenter} from "@/lib/store/validator/center/abstract/AbstractValidatorCenter";
import EncapsulatedValidator from "@/lib/store/validator/center/abstract/type/EncapsulatedValidator";
import {SSegmentedImage} from "@/store/Spatial2DAnnotation/model/SSegmentedImage";

export class SegmentedImageValidatorCenter extends AbstractValidatorCenter<SSegmentedImage>
{
    protected encapsulatedValidators: EncapsulatedValidator[] = [

    ];
}